export const loadConfig = async () => {
  try {
    const response = await fetch("/config.json");
    if (!response.ok) throw new Error("Error cargando config.json");
    const config = await response.json();
    return config;
  } catch (error) {
    console.error("No se pudo cargar config.json:", error);
    return null;
  }
};
